import { render, staticRenderFns } from "./JoinR.vue?vue&type=template&id=86acabc2&scoped=true"
import script from "./JoinR.vue?vue&type=script&lang=js"
export * from "./JoinR.vue?vue&type=script&lang=js"
import style0 from "./JoinR.vue?vue&type=style&index=0&id=86acabc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86acabc2",
  null
  
)

export default component.exports